import {FormProvider, useForm} from "react-hook-form";

import {EntityForm} from "base/entity/components/form";

const PermitExtensionMaterialsForm = ({extension, onSubmit = null, children}) => {
    const materials = extension?.material_set;

    const formMethods = useForm({
        defaultValues: {
            materials: materials?.reduce((acc, material) => {
                acc[material.id] = {
                    is_extended: material.is_extended || false,
                    quantity_ext: material.quantity_ext || null,
                };
                return acc;
            }, {}),
        },
    });

    const {
        formState: {isDirty},
    } = formMethods;

    const handleSubmit = data => {
        onSubmit(
            Object.entries(data.materials).map(([materialId, values]) => ({
                material_id: Number(materialId),
                is_extended: !!values.is_extended,
                quantity_ext: values.is_extended ? values.quantity_ext : null,
            }))
        );
    };

    return (
        <FormProvider {...formMethods}>
            <EntityForm
                onSubmit={onSubmit ? formMethods.handleSubmit(handleSubmit) : null}
                isFormDirty={isDirty}
            >
                {children}
            </EntityForm>
        </FormProvider>
    );
};

export default PermitExtensionMaterialsForm;
